import type { AppointmentEmailOutcome } from "../../../../../../../api/kehrblatt/schedule-events"

export type AppointmentDecisionKind = "confirmed" | "rescheduled"

export type AppointmentDecisionNotification = {
  class: "success" | "warning" | "error"
  html: string
}

const SKIP_REASON_LABELS: Record<string, string> = {
  missing_recipient: "Keine E-Mail-Adresse beim Kunden hinterlegt",
  missing_work_order: "Kein Auftrag zugeordnet",
  missing_case: "Kein Vorgang zugeordnet",
  event_not_confirmed: "Termin ist nicht bestätigt",
  already_sent: "Bestätigungs-E-Mail wurde bereits gesendet",
  not_recorded: "Keine sichere E-Mail-Adresse beim Kunden hinterlegt",
}

export const formatEmailSkipReason = (
  skippedReason?: string | null,
  detail?: string | null,
): string => {
  const key = (skippedReason ?? "").trim()

  if (SKIP_REASON_LABELS[key]) {
    return SKIP_REASON_LABELS[key]
  }

  const normalizedDetail = (detail ?? "").trim().replace(/\.$/, "")

  if (normalizedDetail) {
    return normalizedDetail
  }

  return "E-Mail-Versand übersprungen"
}

export const buildAppointmentDecisionNotification = (
  action: AppointmentDecisionKind,
  outcome: AppointmentEmailOutcome,
): AppointmentDecisionNotification => {
  const base = action === "rescheduled" ? "Termin verschoben und bestätigt" : "Termin bestätigt"

  if (outcome.status === "not_requested") {
    return {
      class: "success",
      html: `${base}.`,
    }
  }

  if (outcome.status === "queued") {
    const recipient = outcome.email_recipient?.trim()
    const recipientSuffix = recipient ? ` an ${recipient}` : ""
    const mailLabel =
      action === "rescheduled" ? "Terminverschiebung per E-Mail" : "Terminbestätigung per E-Mail"

    return {
      class: "success",
      html: `${base} (${mailLabel}${recipientSuffix} gesendet).`,
    }
  }

  const reason = formatEmailSkipReason(outcome.skipped_reason, outcome.detail)

  return {
    class: "warning",
    html: `${base}. E-Mail nicht gesendet: ${reason}.`,
  }
}
